import { render, staticRenderFns } from "./BOMSearch.vue?vue&type=template&id=4e56ea1e&scoped=true&"
import script from "./BOMSearch.vue?vue&type=script&lang=js&"
export * from "./BOMSearch.vue?vue&type=script&lang=js&"
import style0 from "./BOMSearch.vue?vue&type=style&index=0&id=4e56ea1e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e56ea1e",
  null
  
)

export default component.exports